<template>
  <div class="no-data">
    <NoFilterTableData />
    <h5>
      <slot name="text">
        We weren't able to find the data you were filtering for.
      </slot>
    </h5>
  </div>
</template>

<script setup>
import NoFilterTableData from '@/assets/no-filter-table-data.svg?component';
</script>

<style scoped lang="less">
.no-data {
  background: @white;
  border-radius: 10px;
  height: 416px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  h5 {
    transform: translateY(-35px);
    color: @text-light;
  }
}
</style>
